import React, { createRef, useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  CardContent,
  Checkbox,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  Card,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { capitalizeFirstLetter } from "../../components/reusableComponent/CapitalLetter";
import { formatDate } from "../../components/reusableComponent/DateFormat";
import LoadingSpinner from "../../components/LoadingSpinner";
import { maskEmail, maskPhoneNumber } from "../reusableComponent/MaskedFields";

interface IProps {
  listOfLeads: any;
  taskRes: any;
  CampaignWorkflow: any;
  setStoreKey: any;
  setValue: any;
  value: any;
  currentPage;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  useData: any;
  campign: any;
  setSelectedTickets;
  selectedTickets: any;
  selectedOptions: any;
  checkTenant: any;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
}

const CampaignCardView: React.FC<IProps> = ({
  listOfLeads,
  checkTenant,
  taskRes,
  CampaignWorkflow,
  setStoreKey,
  setValue,
  value,
  currentPage,
  setCurrentPage,
  campign,
  setSelectedTickets,
  selectedTickets,
  selectedOptions,
  pageSize,
  setPageSize,
}) => {
  const taskResActionMenuRef = useRef<any[]>([]);
  taskResActionMenuRef.current = taskRes.map(
    (item: any, i: number) => taskResActionMenuRef.current[i] ?? createRef()
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [selectAll, setSelectAll] = useState(false);
  const [uiData, setUiData] = useState([]);
  const [keyState, setKeyState] = useState([]);
  const [ticketTabLoading, setTicketTabLoading] = useState<boolean>(false);
  const ticketCount = campign?.count ? campign?.count : 0;

  const checkUserRole = localStorage.getItem("user_role");
  const pageSizeOptions = [5, 10, 20, 50, 100];

  const rows =
    campign?.results?.map((campign: any) => ({
      broadCast: campign?.broadcast_msg,
      id: campign?.id,
      status_type: campign?.status_type,
      displayName: campign?.status_display,
      account_name: campign?.account_name,
      created: campign?.created,
      assignee: campign?.assignee?.username,
      raisedBy: campign?.created_by?.username,
      mobile: campign?.phone_number,
      email: campign?.email,
      is_high_priority: campign?.is_high_priority,
    })) || [];

  const handleSelect = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: number
  ) => {
    const newSelectedTickets = event.target.checked
      ? [...selectedTickets, id]
      : selectedTickets.filter((ticketId) => ticketId !== id);

    setSelectedTickets(newSelectedTickets);

    // Uncheck "Select All" if any checkbox is unchecked
    if (!event.target.checked) {
      setSelectAll(false);
    }
  };

  const getStatusStyle = (status_type: string) => {
    switch (status_type) {
      case "active":
        return { backgroundColor: "#009DFF", color: "white" };
      case "closed":
        return { backgroundColor: "#198754", color: "white" };
      case "reopen":
        return { backgroundColor: "#90EE90", color: "white" };
      case "wip":
        return { backgroundColor:"#ffc107" , color: "black" };
      default:
        return { backgroundColor: "#6c757d", color: "white" };
    }
  };
  

  const truncateDescription = (description, maxLength) => {
    if (description?.length > maxLength) {
      return description?.slice(0, maxLength) + "...";
    }
    return description;
  };

  const processData = async () => {
    const uiFormattedData = [];
    const keysForState = [];

    if (CampaignWorkflow && typeof CampaignWorkflow === "object") {
      await Object.entries(CampaignWorkflow)?.forEach(([key, value]) => {
        if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value)
        ) {
          Object.entries(value).forEach(([nestedKey, nestedValue]) => {
            uiFormattedData.push({
              key: nestedKey,
              value: nestedValue,
            });
            keysForState.push(key);
          });
        } else if (Array.isArray(value)) {
          value.forEach((item) => {
            if (item && typeof item === "object") {
              Object.entries(item).forEach(([nestedKey, nestedValue]) => {
                uiFormattedData.push({
                  key: nestedKey,
                  value: nestedValue,
                });
                keysForState.push(key);
              });
            }
          });
        }
      });

      setUiData(uiFormattedData);
      setKeyState(keysForState);
    } else {
      console.error("Campign is undefined or null");
    }
  };

  useEffect(() => {
    processData();
  }, [CampaignWorkflow]);

  const totalPages = Math.ceil(ticketCount / pageSize);

  const handlePageSizeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const newPageSize = parseInt(event.target.value);
    setPageSize(newPageSize);
    setCurrentPage(1); // Reset to first page when changing page size
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, [currentPage]);

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectAll(event.target.checked);
    if (event.target.checked && campign?.results.length > 0) {
      setSelectedTickets(campign?.results.map((row) => row.id));
    } else {
      setSelectedTickets([]);
    }
  };

  useEffect(() => {
    if (campign && campign.results) {
      if (
        campign?.results.length > 0 &&
        selectedTickets.length === campign.results.length
      ) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    } else {
      setSelectAll(false);
    }
  }, [selectedTickets, campign]);

  useEffect(() => {
    setTicketTabLoading(true);
    setTimeout(() => {
      setTicketTabLoading(false);
    }, 3000);
  }, [value]);

  const tenant= localStorage.getItem("circleone-user");

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
           <div className="tabs-header-section">
               <div className="tabs-header-content">
                 <input
                   type="checkbox"
                   checked={selectAll}
                   onChange={handleSelectAll}
                   className="select-all-checkbox"
                 />
                 <Tabs
                   value={uiData.findIndex((item) => item.key === value)}
                   onChange={(_, newValue) => {
                     setStoreKey(keyState[newValue]);
                     setValue(uiData[newValue].key);
                     setCurrentPage(1);
                   }}
                   variant="scrollable"
                   scrollButtons="auto"
                   sx={{
                     flex: 1,
                     minHeight: "44px",
                     backgroundColor: "#ffffff",
                     "& .MuiTabs-indicator": {
                       backgroundColor: "#6366f1",
                       height: "2px",
                     },
                     "& .MuiTab-root": {
                       textTransform: "none",
                       minHeight: "44px",
                       fontSize: "14px",
                       fontWeight: 500,
                       color: "#6c757d",
                       padding: "10px 20px",
                       transition: "all 0.2s ease",
                       minWidth: "auto",
                       "&:hover": { color: "#495057", backgroundColor: "#f8f9fa" },
                       "&.Mui-selected": { color: "#6366f1", fontWeight: 600 },
                     },
                     "& .MuiTabs-scrollButtons": {
                       color: "#6c757d",
                       "&.Mui-disabled": { opacity: 0.3 },
                     },
                   }}
                 >
                   {uiData.map((info, index) => (
                     <Tooltip key={index} title={`${info.key} (${info.value})`} arrow>
                       <Tab
                         label={truncateDescription(`${info.key} (${info.value})`, 25)}
                       />
                     </Tooltip>
                   ))}
                 </Tabs>
               </div>
             </div>

          {/* Scrollable Content Container */}
          <div
            style={{
              height: "calc(100vh - 400px)", // Adjust based on your layout
              overflow: "auto",
              overflowX: "hidden",
            }}
          >
            {ticketTabLoading ? (
              <LoadingSpinner />
            ) : (
              <div
                className="tab-content d-flex"
                style={{
                  position: "relative",
                  width: "100%",
                  overflow: "scroll",
                }}
              >
                <div className="row g-9">
                  <div className="col-md-12">
                    <div
                      style={{
                        marginLeft: "40px",
                        display: "grid",
                        gridTemplateColumns: "repeat(5, 1fr)", // alternative
                        gap: "16px",
                        padding: "16px 0",
                      }}
                    >
                      <input
                        type="checkbox"
                        className=" mb-xl-9 h-100"
                        style={{
                          marginTop: "18px",
                          position: "absolute",
                          top: "-43%",
                          left: "14px",
                          backgroundColor: "black",
                          cursor: "pointer",
                          width: "15px",
                          borderColor: "black",
                          borderWidth: "4px",
                          borderStyle: "solid",
                        }}
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />

                      {rows?.map((row: any) => (
                        <div
                          key={row.id}
                          className="d-flex flex-column mx-5 p-2"
                          style={{ flex: "1 1 340px", minWidth: "340px" }}
                        >
                          <Link
                            to={`/campaign/lead/${row.id}`}
                            className=" fs-5 fw-bold flex-grow-1"
                          >
                            <Card
                              key={row.id}
                              className="mb-6 mb-xl-9"
                              style={{
                                minHeight: "350px",
                                display: "flex",
                                flexDirection: "column",
                                transition:
                                  "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(-2px)";
                                e.currentTarget.style.boxShadow =
                                  "0 4px 12px rgba(0,0,0,0.15)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                                e.currentTarget.style.boxShadow =
                                  "0 2px 4px rgba(0,0,0,0.1)";
                              }}
                            >
                              <CardContent>
                                <div
                                  className="d-flex align-items-center mb-3"
                                  style={{ marginLeft: "-10px" }}
                                >
                                  <Checkbox
                                    checked={selectedTickets.includes(row.id)}
                                    onChange={(event) =>
                                      handleSelect(event, row.id)
                                    }
                                    onClick={(e) => e.stopPropagation()}
                                  />

                                  <Typography className="fs-6 fw-semibold text-gray-600">
                                    {row?.id}
                                  </Typography>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <div
                                    className="badge badge-light"
                                    style={{
                                      ...getStatusStyle(row.status_type),
                                    }}
                                    data-bs-toggle="tooltip"
                                    title={row.status_display}
                                  >
                                    <span className="fw-bold">
                                      Status:{" "}
                                      {truncateDescription(row.displayName, 10)}
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    {row?.is_high_priority ? (
                                      <div
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        title="High Priority"
                                      >
                                        <i
                                          className="bi bi-flag-fill"
                                          style={{
                                            color: "red",
                                            fontSize: "15px",
                                          }}
                                        ></i>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        title="Low priority"
                                      >
                                        <i
                                          className="bi bi-flag-fill"
                                          style={{
                                            color: "#45cf45",
                                            fontSize: "15px",
                                          }}
                                        ></i>
                                      </div>
                                    )}
                                    {checkTenant === "meta" && (
                                      <div>
                                        {console.log(row, "SDccscs")}
                                        {row?.broadCast === true ? (
                                          <i
                                            className="bi bi-check-circle-fill text-success"
                                            style={{
                                              fontSize: "1.1rem",
                                            }}
                                            title="Whatsapp broadcast sent successfully"
                                          ></i>
                                        ) : row.broadCast === "false" ? (
                                          <i
                                            className="bi bi-x-circle-fill text-danger"
                                            style={{
                                              fontSize: "1.1rem",
                                            }}
                                            title="Message Sending Failed"
                                          ></i>
                                        ) : (
                                          <i
                                            className="bi bi-dash-circle-fill text-muted"
                                            style={{
                                              fontSize: "1.2rem",
                                            }}
                                            title="Message Not Sent"
                                          ></i>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <Typography className="fs-6 fw-semibold text-gray-600 mb-3">
                                  Account name:{" "}
                                  {truncateDescription(row.account_name, 10)}
                                </Typography>
                                <Typography className="fs-6 fw-semibold text-gray-600 mb-3">
                                  Created at: {formatDate(row.created)}
                                </Typography>
                                <Typography className="fs-6 fw-semibold text-gray-600 mb-3">
                                  Assignee:{" "}
                                  {capitalizeFirstLetter(
                                    row.assignee === undefined
                                      ? "Unassigned"
                                      : row.assignee
                                  )}
                                </Typography>
                                <Typography className="fs-6 fw-semibold text-gray-600 mb-3">
                                  Created by:{" "}
                                  {capitalizeFirstLetter(row.raisedBy)}
                                </Typography>
                                <Typography className="fs-6 fw-semibold text-gray-600 mb-3">
                                  Priority:{" "}
                                  <span
                                    style={{
                                      color: row.is_high_priority
                                        ? "red"
                                        : "#45cf45",
                                    }}
                                  >
                                    {capitalizeFirstLetter(
                                      row.is_high_priority ? "High" : "Low"
                                    )}
                                  </span>
                                </Typography>
                                <Typography className="fs-6 fw-semibold text-gray-600 mb-3">
                                  Mobile no:{" "}
                                  {(checkUserRole === "agent" && tenant == "briezi")
                                    ? maskPhoneNumber(row.mobile)
                                    : row.mobile}
                                </Typography>
                                <Typography className="fs-6 fw-semibold text-gray-600 mb-5">
                                  Email:{" "}
                                  {(checkUserRole === "agent" && tenant === "briezi")
                                    ? maskEmail(row.email)
                                    : capitalizeFirstLetter(row.email)}
                                </Typography>
                              </CardContent>
                            </Card>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}

      {/* Fixed Pagination Footer */}
      <div
        style={{
          position: "sticky",
          bottom: 0,
          zIndex: 10,
        }}
      >
        <div
          className="d-flex justify-content-between align-items-center mt-4 px-2"
          style={{ marginBottom: "8px" }}
        >
          {/* Left: Rows per page */}
          <div className="d-flex align-items-center gap-4">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                Show
              </span>
              <select
                className="form-select form-select-sm"
                style={{
                  width: "60px",
                  fontSize: "14px",
                  padding: "2px 6px",
                }}
                name="perpage"
                value={pageSize}
                onChange={handlePageSizeChange}
              >
                {pageSizeOptions.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#495057",
                }}
              >
                per page
              </span>
            </div>
          </div>

          {/* Right: Pagination */}
          <div
            className="d-flex align-items-center"
            style={{ paddingRight: "8px" }}
          >
            <Pagination
              sx={{
                display: "flex",
                justifyContent: "end",
                "& .MuiPaginationItem-root": {
                  fontSize: "14px",
                  minWidth: "36px",
                  height: "36px",
                  margin: "0 2px",
                  borderRadius: "6px",
                  border: "1px solid #e5e7eb",
                  color: "#374151",
                  "&:hover": {
                    backgroundColor: "#f9fafb",
                    borderColor: "#d1d5db",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#6366f1",
                    color: "#ffffff",
                    borderColor: "#6366f1",
                    "&:hover": {
                      backgroundColor: "#4f46e5",
                      borderColor: "#4f46e5",
                    },
                  },
                },
              }}
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              showFirstButton
              showLastButton
              renderItem={(item) => {
                if (item.type === "page") {
                  const isNearCurrent =
                    Math.abs(item.page - currentPage) <= 1 ||
                    item.page === 1 ||
                    item.page === totalPages;
                  return isNearCurrent ? <PaginationItem {...item} /> : null;
                }
                return <PaginationItem {...item} />;
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CampaignCardView;
